import React from 'react'
import useCheckScreenWidth from './useCheckScreenWidth';

const useConditionalGrid = (el=[]) => {
    const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

    const gridCondition = el?.length>1 && screenWidth > 1024;

    return  gridCondition
}

export default useConditionalGrid
